module.exports = __webpack_public_path__ + "img/0xe65b462b90516012826f8a9c4c285d8c750e3a77.b86c8e88.png";